import request from '@/utils/http'

const PREFIX = '/user'

const user = {
  resetPwd(id, params) {
    return request(
      `${PREFIX}/resetPassWord/${id}`,
      'put',
      params
    )
  },

  create(params) {
    return request(
      `${PREFIX}`,
      'post',
      params
    )
  },

  update(id, params) {
    return request(
      `${PREFIX}/${id}`,
      'put',
      params
    )
  },

  updateState(id, params) {
    return request(
      `${PREFIX}/updateState/${id}`,
      'put',
      params
    )
  },

  updateMiniState(id, params) {
    return request(
      `${PREFIX}/updateMiniState/${id}`,
      'put',
      params
    )
  },

  tenantUpdate(id, params) {
    return request(
      `${PREFIX}/tenant/${id}`,
      'put',
      params
    )
  },

  signIn(params) {
    return request(
      '/user/signIn',
      'post',
      params
    )
  },

  captcha() {
    return request(
      '/user/captcha',
      'get',
      {},
      { 'Content-Type': 'application/json;charset=UTF-8' }
    )
  },

  signUp(params) {
    return request(
      '/user/signUp',
      'post',
      params
    )
  },

  getInfo() {
    return request(
      '/user/profile',
      'get'
    )
  },

  page(params) {
    return request(
      '/user',
      'get',
      params
    )
  },

  tenant(params) {
    return request(
      '/user/tenant',
      'get',
      params
    )
  },

  updateCurrent(params) {
    return request(
      '/user/current',
      'put',
      params
    )
  },

  updatePassword(params) {
    return request(
      '/user/updatePassword',
      'put',
      params
    )
  },
  getUserProject(id) {
    return request(
      `${PREFIX}/userProject/${id}`,
      'get'
    )
  },
  getTenantUserProject(id) {
    return request(
      `${PREFIX}/tenant/userProject/${id}`,
      'get'
    )
  },
  getUserList(projectId) {
    return request(
      `${PREFIX}/userList/${projectId}`,
      'get'
    )
  },
  authorizeProjects(param) {
    return request(
      `${PREFIX}/authorizeProjects`,
      'post',
      param
    )
  },
  userLoginLog(userId, params) {
    return request(
      `${PREFIX}/getLoginLogs/${userId}`,
      'get',
      params
    )
  },
  show(userId) {
    return request(
      `${PREFIX}/${userId}`,
      'get'
    )
  },
  unBindAccount(id, params) {
    return request(
      `${PREFIX}/unBindAccount/${id}`,
      'post',
      params
    )
  },
  editRoles() {
    return request(
      `${PREFIX}/editRoles`,
      'get'
    )
  },
  getLoginQr() {
    return request(
      `${PREFIX}/getLoginQr`,
      'get'
    )
  },
  getMiniAppList() {
    return request(
      `${PREFIX}/miniApp/list`,
      'get'
    )
  },
  qrCodeIsLogin(uuId) {
    return request(
      `${PREFIX}/qrCode/isLogin`,
      'get',
      {},
      { 'uuId': uuId }
    )
  },
  getTenantUsers() {
    return request(
      `${PREFIX}/tenant/all`,
      'get'
    )
  }
}

export default user
